// extracted by mini-css-extract-plugin
module.exports = {"bb-time-spent":"bb-time-spent__57p1z"};